import tree from '../data/baobab';
import Keycloak from 'keycloak-js';

const endpoint = process.env.NODE_ENV === 'production' ? '//api-overseer.farseer.xyz/api/v1' : 'api/v1';

console.log('process.env.NODE_ENV', process.env.NODE_ENV);
console.log('endpoint', endpoint);

const keycloak = Keycloak({
    url: 'https://login.farseer.io/auth',
    realm: 'master',
    clientId: 'overseer',
});

keycloak
    .init({
        onLoad: 'login-required',
        checkLoginIframe: false,
    })
    .then((authenticated) => {
        const { realm, realmAccess, resourceAccess, sessionId, token, tokenParsed, refreshToken } = keycloak;
        if (authenticated && realmAccess?.roles.includes('overseer')) {
            tree.select('keycloak').set({
                realm,
                realmAccess,
                resourceAccess,
                sessionId,
                token,
                tokenParsed,
                refreshToken,
                authenticated,
            });
        }
    });

keycloak.onTokenExpired = () => {
    keycloak.updateToken(30).then((authenticated) => {
        const { realm, realmAccess, resourceAccess, sessionId, token, tokenParsed, refreshToken } = keycloak;
        if (authenticated && realmAccess?.roles.includes('overseer')) {
            tree.select('keycloak').set({
                realm,
                realmAccess,
                resourceAccess,
                sessionId,
                token,
                tokenParsed,
                refreshToken,
                authenticated,
            });
        } else {
            tree.select('keycloak').set({});
        }
    });
};

function getRequestHeaders() {
    const requestHeaders = new Headers();
    requestHeaders.set('Content-Type', 'application/json');
    requestHeaders.set('Accept', 'application/json');
    const token = tree.get('keycloak', 'token');
    if (token) {
        requestHeaders.set('Authorization', 'Bearer ' + token);
    }
    return requestHeaders;
}

export enum Method {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
}

export async function request(method: Method, url: string, payload?: any): Promise<any> {
    const response = await fetch(endpoint + url, {
        method: method,
        headers: getRequestHeaders(),
        body: payload ? JSON.stringify(payload) : undefined,
    });
    const status = response.status;

    let json = {};
    try {
        json = await response.json();
    } catch (e) {
        console.log('error getting json response');
        console.error(e);
    }

    return {
        status,
        payload: json,
    };
}

export async function logout() {
    await keycloak.logout();
}
